import { BankGet, Get, Post, Put, getAPIUrl } from "./apiMethod";
import {  Globalendpoints , Authendpoint } from "./global";



export const getCountry = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getCountry, param);
  return Get(url);
};

export const getDashBoard = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getDashBoard, param);
  return Get(url);
};

export const getProfile = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getProfile, param);
  return Get(url);
};
export const updateProfile = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updateProfile, param);
  return Put(url, data);
};



export const getDashBoardCharts = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getDashBoardCharts, param);
  return Get(url);
};

export const userRegister = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.register, param);
  return Post(url, data);
};


export const addRestro = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.addRestro, param);
  return Post(url, data);
};

export const getCategoryList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getCategoryList, param);
  return Get(url);
};
export const getordersDetails = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getordersDetails, param);
  return Get(url);
};


export const getBrand= (param = "") => {
  const url = getAPIUrl(Globalendpoints.brandlist, param);
  return Get(url);
};

export const addBrand = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.addbrand, param);
  return Post(url, data);
};


export const editBrand = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.editBrand, param);
  return Put(url, data);
};



export const getrestroList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getrestroList, param);
  return Get(url);
};
export const getrestroPermissionsList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getrestroPermissionsList, param);
  return Get(url);
};
export const gettransactionList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.gettransactionList, param);
  return Get(url);
};

export const getallrestroList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getallrestroList, param);
  return Get(url);
};

export const restroDisabled = ( param = "") => {
  const url = getAPIUrl(Globalendpoints.restroDisabled, param);
  return Get(url);
};
export const updateRole = (param = "") => {
  const url = getAPIUrl(Globalendpoints.updateRole, param);
  return Get(url);
};


export const settledAmount = ( param = "") => {
  const url = getAPIUrl(Globalendpoints.settledAmount, param);
  return Get(url);
};

export const vendorDisable = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.vendorDisable, param);
  return Post(url, data);
};



export const addCategory = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.addCategory, param);
  return Post(url, data);
};
export const getVendorsDetails = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getVendorsDetails, param);
  return Get(url);
};
 
export const getState = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.getState, param);
  return Post(url, data);
};
export const loginApi = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.loginApi, param);
  return Post(url, data, false);
};
export const getCity = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.getCity, param);
  return Post(url, data);
};
export const getBanks = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getBanks, param);
  return Get(url);
};
export const getMemberServices = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getMemberServices, param);
  return Get(url);
};

export const getmemberType = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getmemberType, param);
  return Get(url);
};


export const GetWalletBalance = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getwalletBalance, param);
  return Get(url);
};

export const getAllAepsMasters = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getMasters, param);
  return Get(url);
};
export const getAllAepsMaster = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getMaster, param);
  return BankGet(url);
};
export const getAllAepsYesMasters = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getYesMasters, param);
  return Get(url);
};
export const merchantOnboard = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.merchantOnboard, param);
  return Post(url, data);
};
export const terminalOnboard = (param = "") => {
  const url = getAPIUrl(Globalendpoints.terminalOnboard, param);
  return Get(url);
};

export const AepsEkycSendOtp = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.sendOtp, param);
  return Post(url, data);
};
export const AepsKycValidateOtp = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.validateOtp, param);
  return Post(url, data);
};
export const AepsKycResnddOtp = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.resendOtp, param);
  return Post(url, data);
};
export const AepsKycBiometric = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.biometric, param);
  return Post(url, data);
};
export const AepsTwoFactorAuth = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.twoFactorauth, param);
  return Post(url, data);
};
export const AepsCashWithdrawl = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.cashwithdrawl, param);
  return Post(url, data);
};
export const AepsBalanceEnquiry = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.balanceEnquiry, param);
  return Post(url, data);
};
export const AepsAadharpay = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.aadharPay, param);
  return Post(url, data);
};
export const AepsMinistatement = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.miniStatement, param);
  return Post(url, data);
};
export const MemberProfile = (param = "") => {
  const url = getAPIUrl(Globalendpoints.Profile, param);
  return Get(url);
};



